'use strict';

window.console || (window.console = {
	log: function log() {}
});

window.browserCheck = {
	ua: navigator.userAgent.toLowerCase(),
	app: navigator.appVersion.toLowerCase()
};
window.config = {
	url: document.URL.split('/'),
	useMac: browserCheck.ua.indexOf('mac') != -1,
	useiPhone: browserCheck.ua.indexOf('iphone') != -1,
	useiPad: browserCheck.ua.indexOf('ipad') != -1,
	useiPod: browserCheck.ua.indexOf('ipod') != -1,
	useAndroid: browserCheck.ua.indexOf('android') != -1
};
window.ms = {
	ie: browserCheck.ua.indexOf('msie') != -1,
	ie6: browserCheck.ua.indexOf('msie 6.') != -1,
	ie7: browserCheck.ua.indexOf('msie 7.') != -1,
	ie8: browserCheck.ua.indexOf('msie 8.') != -1
};

var FUNCTIONS = window.FUNCTIONS || null;

(function ($) {
	var siteName = 'KURODA';

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: $(window).width(),
				height: $(window).height()
			}
		},
		localDecision: function localDecision() {
			var regExp = new RegExp('(test.' + siteName + '.co.jp|copre.jp|localhost|192.168.0.|192.168.11.|192.168.1.)', 'g');
			return regExp.test(location.hostname);
		},
		localLoading: function localLoading() {
			var _this = this;
			// ローカル環境ならincludeをAjaxで読み込む
			var key = 'inc_';
			var ajaxArray = [];
			var ajaxArrayList = [];
			var i, j;
			var includeClass = document.querySelectorAll('[class*="' + key + '"]');
			var includeClassLen = includeClass.length;

			for (i = 0; i < includeClassLen; i++) {
				var path = includeClass[i].innerHTML.split(' ')[1];
				ajaxArray.push(path);
			}
			var ajaxLen = ajaxArray.length;

			if (ajaxLen > 0) {
				for (i = 0; i < ajaxLen; i++) {
					ajaxArrayList[i] = $.ajax({
						type: 'GET',
						url: ajaxArray[i] + '.html',
						dataType: 'html',
						timeout: 5000
					});
				}
				$.when.apply($, ajaxArrayList).done(function () {
					for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
						args[_key] = arguments[_key];
					}

					var regExp = new RegExp(key);

					for (i = 0; i < args.length; i++) {
						var result = args[i];
						var position = $(result[0]).filter(':first').attr('class').split(' ');

						for (j = 0; j < position.length; j++) {
							if (position[j].match(regExp)) {
								position = position[j];
								break;
							}
						}
						$('.' + position).html(result[0]).children().unwrap();

						console.log('Succeeded to read the include file!:', position);
					}
					_this.loadDelayScript();
				});
			} else {
				_this.loadDelayScript();
			}
		},
		catchAjaxError: function catchAjaxError(_errorThrown) {
			if (window.ga) {
				window.ga('send', 'event', 'ajaxError', location.href, _errorThrown, 0, true);
			}
		},
		getQuery: function getQuery() {
			var vars = [];
			var hash = null;
			var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			for (var i = 0; i < hashes.length; i++) {
				hash = hashes[i].split('=');
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			}
			return vars;
		},
		setNav: function setNav() {
			var nav = document.getElementById('navigation');
			var once = true;

			// Set navigation active class.
			$(nav).find('li').each(function () {
				var cls = this.getAttribute('class');

				if (location.pathname.split('/')[1] == cls) {
					if (this.classList) {
						this.classList.add('active');
					} else {
						this.className += ' ' + 'active';
					}
				}
			});

			$('.mod_menu').find('ul > li > a').each(function () {
				var path = this.getAttribute('href');
				if (location.pathname == path || location.pathname.slice(0, -1) == path) {
					$(this).addClass('active');
				}
			});
			// Submenu display control
			$('.mod_menu .subMenu').each(function () {
				var $this = $(this);
				var path = location.pathname;
				var targetLink = $this.prev('a').attr('href');

				if (path.indexOf(targetLink) >= 0) {
					$this.show().prev('a').addClass('active');
				}
				$this.find('li').each(function () {
					if (path == $(this).find('a').attr('href')) {
						$(this).addClass('active');
					}
				});
			});
		},
		setNewsList: function setNewsList() {
			var body = document.getElementById('container');
			var newsList = document.getElementById('newsList');
			var newsListLi = $(newsList).find('.tabs li');
			var article = document.querySelectorAll('.newsData li');
			var category = [];

			if (newsList) {
				$(article).each(function () {
					var iconClass = $(this).find('.icon').attr('class').replace(/rt_cf_n_category_icon /, '').replace(/ icon/, '');

					if ($.inArray(iconClass, category) < 0) {
						category.push(iconClass);
					}
				});

				if ($('.tabs', newsList).find('li').attr('data-tabs') == 'all') {
					$(article).fadeIn(500, function () {
						$('.newsData ul').perfectScrollbar('update');
					});
				} else {
					$(article).hide();
					$(article).find('.' + category[0]).closest('li').fadeIn(500, function () {
						$('.newsData ul').perfectScrollbar('update');
					});
				}

				$(newsListLi).each(function () {
					var $this = $(this);
					if ($this.is('.is-disable')) {
						$this.css({
							'text-decoration': 'none',
							'color': '#333',
							'background': '#eee',
							'cursor': 'default'
						});
					}
				}).on('click', function () {
					var $this = $(this);

					if (!$this.is('.is-disable')) {
						var getTabs = $this.attr('data-tabs');
						var idx = $.inArray(getTabs, category);

						$(newsListLi).removeClass('active');
						$this.addClass('active');

						$(article).hide();
						if (idx >= 0) {
							$(article).find('.' + category[idx]).closest('li').fadeIn(500, function () {
								$('.newsData ul').perfectScrollbar('update');
							});
						} else {
							$(article).fadeIn(500, function () {
								$('.newsData ul').perfectScrollbar('update');
							});
						}
					}
				});
				$('.newsData ul').perfectScrollbar();

				if ($(body).is('.dir_ir')) {
					$('.irListLv2 li').tile(2);
				}
			}
		},
		smoothScroll: function smoothScroll() {
			$('a[rel="scroll"]').on('click', function () {
				var req1 = location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '');
				var req2 = location.hostname == this.hostname;

				if (req1 && req2) {
					var target = $(this.hash);
					target = target.length && target;

					if (target.length) {
						var scldurat = 1200;
						var targetOffset = target.offset().top - 1;
						$('html,body').animate({ scrollTop: targetOffset }, scldurat, 'easeOutExpo');
						return false;
					}
				}
			});
		},
		setCompanyProf: function setCompanyProf() {
			$('.dir_profile .company th span a').on('click', function () {
				var dataId = this.getAttribute('data-id');
				if (dataId) {
					try {
						window.open(this.href, '', 'width=850,height=700, menubar=no, toolbar=no, scrollbars=yes');
					} catch (e) {
						location.href = this.href;
					}
				}
				return false;
			});
			var regionArray = [];
			$('.dir_profile section.company').find('h3.headDotted').each(function () {
				regionArray.push(this.id);
			});

			$('.dir_profile section.wrap li').each(function () {
				var regionHref = $(this).find('a').attr('href').slice(1);
				if (regionArray.indexOf(regionHref) == -1) {
					var anchorText = $(this).find('a').text();
					$(this).find('a').remove().end().text(anchorText);
				}
			});
		},
		fileSize: function fileSize() {
			$('.js-fileSize').each(function (idx, ele) {
				$(ele).text(bytesToSize($(ele).text()));
			});

			function bytesToSize(bytes) {
				var sizes = ['Bytes', 'KB', 'MB', 'GB'];
				if (bytes === 0) return '0 Byte';
				var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
				var convSize = Math.floor(bytes / Math.pow(1024, i) * Math.pow(10, 1)) / Math.pow(10, 1);
				// KBのとき、小数点切り捨て
				if (i === 1) convSize = Math.floor(convSize);
				return convSize + sizes[i];
			}
		},
		modalImg: function modalImg() {
			$('.mod-modal').on('click', function (e) {
				var HTML = '<div class="mod-modal-overlay">';
				HTML += '<div class="mod-modal-closeArea"></div>' + '<span class="mod-modal-closeBtn"><img src="/common/images/close.png"></span>' + ($(e.currentTarget).find('img').prop('outerHTML') + '</div>');
				$('body').append(HTML);

				var $overlay = $('.mod-modal-overlay');
				$overlay.addClass('is-active');
				setTimeout(function () {
					$overlay.addClass('is-visible');

					$('.mod-modal-closeArea, .mod-modal-closeBtn').on('click', function () {
						$overlay.removeClass('is-visible');
						setTimeout(function () {
							$overlay.removeClass('is-active');
							$overlay.remove();
						}, 400);
					});
				});
			});
		},
		setNewsYear: function setNewsYear() {
			var latestYearMonth = document.getElementsByClassName('rt_latest_year_month')[0];
			var year_month = latestYearMonth.textContent;
			var myYear = year_month.substr(0, 4);
			var myMonth = year_month.substr(4, 2);
			var lastYear = myYear < 2000 ? myYear + 1900 : myYear;
			lastYear = myMonth > 3 ? lastYear : lastYear - 1;

			var htmlstr = '';
			if (location.pathname.indexOf('/english/') === -1) {
				for (var i = lastYear; i >= 2015; i--) {
					htmlstr = htmlstr + '<li><a href="/news/' + i + '/">' + i + '年</a></li>';
				}
			} else {
				for (var _i = lastYear; _i >= 2015; _i--) {
					htmlstr = htmlstr + '<li><a href="/english/news/' + _i + '/">' + _i + '</a></li>';
				}
			}
			$('.mod_menu ul').append(htmlstr);
		},
		setCsrNewsYear: function setCsrNewsYear() {
			var latestYearMonth = document.getElementsByClassName('rt_latest_year_month')[0];
			var year_month = latestYearMonth.textContent;
			var myYear = year_month.substr(0, 4);
			var myMonth = year_month.substr(4, 2);
			var lastYear = myYear < 2000 ? myYear + 1900 : myYear;
			lastYear = myMonth > 3 ? lastYear : lastYear - 1;
			var htmlstr = '';
			for (var i = lastYear; i > 2003; i--) {
				htmlstr = htmlstr + '<li><a href="/csr/environment_activities/kigyo_mori/' + i + '/">' + i + '年</a></li>';
			}
			$('.js-csrNewsNav').append(htmlstr);
		},
		loadDelayScript: function loadDelayScript() {
			var _this = this;
			_this.smoothScroll();
			_this.setCompanyProf();
			_this.modalImg();

			if (location.pathname.indexOf('/news/') !== -1 && location.pathname.indexOf('/ir/news/') === -1) {
				_this.setNewsYear();
			} else if (location.pathname.indexOf('/kigyo_mori/') !== -1) {
				_this.setCsrNewsYear();
			}
			_this.setNewsList();
			_this.fileSize();
			_this.setNav();

			// 高さを揃える
			$.fn.heightLine = function () {
				var thisHeight = [];
				var $this = $(this);
				$this.each(function () {
					thisHeight.push($this.outerHeight());
				});
				$this.css('height', Math.max.apply(null, thisHeight) + 'px');
			};
			$('.js_heightLine, .js_heightLineParent li').heightLine();

			// ブロック要素全体をリンクに置換
			$.fn.blockAnchor = function (value) {
				return this.each(function () {
					var $this = $(this),
					    click = 'click',
					    anchor = $this.find('a'),
					    anchorHref = $(anchor).attr('href');

					if (config.useiPad) click = 'touchstart';
					if (typeof anchorHref !== 'undefined') {
						$this.on({
							'mouseenter': function mouseenter() {
								$this.css(value);
							},
							'mouseleave': function mouseleave() {
								$this.css('opacity', '1');
							},
							click: function click() {
								if (anchor.attr('rel') === 'scroll') {
									var target = $(anchorHref);
									target = target.length && target;

									if (target.length) {
										var sclpos = 150;
										var scldurat = 1200;
										var targetOffset = target.offset().top - sclpos;
										$('html,body').animate({ scrollTop: targetOffset }, { duration: scldurat, easing: 'easeOutExpo' });
										return false;
									}
								} else if (anchor.attr('target') === '_blank') {
									window.open(anchorHref);
									return false;
								} else {
									location.href = anchorHref;
								}
							}
						});
					}
				});
			};
			$('.blockAnchorParent li, .blockAnchor').blockAnchor({
				opacity: '0.6'
			});

			/**
   * Flatten height same as the highest element for each row.
   *
   * Copyright (c) 2011 Hayato Takenaka
   * Dual licensed under the MIT and GPL licenses:
   * http://www.opensource.org/licenses/mit-license.php
   * http://www.gnu.org/licenses/gpl.html
   * @author: Hayato Takenaka (https://github.com/urin/jquery.tile.js)
   * @version: 1.1.0
   **/
			$.fn.tile = function (columns) {
				var tiles,
				    $tile,
				    max,
				    c,
				    h,
				    remove,
				    s = document.body.style,
				    a = ['height'],
				    last = this.length - 1;
				if (!columns) columns = this.length;
				remove = s.removeProperty ? s.removeProperty : s.removeAttribute;
				return this.each(function () {
					remove.apply(this.style, a);
				}).each(function (i) {
					c = i % columns;
					if (c == 0) tiles = [];
					$tile = tiles[c] = $(this);
					h = $tile.css('box-sizing') == 'border-box' ? $tile.outerHeight() : $tile.innerHeight();
					if (c == 0 || h > max) max = h;
					if (i == last || c == columns - 1) {
						$.each(tiles, function () {
							this.css('height', max);
						});
					}
				});
			};
		}
	};

	$(function () {
		return FUNCTIONS.localDecision() ? FUNCTIONS.localLoading() : FUNCTIONS.loadDelayScript();
	});
})(window.jQuery);